import { RESPONSES_ACTION as ACTION_TYPE } from '../types/actionTypes';
const setResponses = dispatch => responses => dispatch({
  type: ACTION_TYPE.SET_RESPONSES,
  payload: {
    responses
  }
});
const setResponsesLoading = dispatch => loading => dispatch({
  type: ACTION_TYPE.SET_RESPONSES_LOADING,
  payload: {
    responsesLoading: loading
  }
});
const setResponsesError = dispatch => error => dispatch({
  type: ACTION_TYPE.SET_RESPONSES_ERROR,
  payload: {
    responsesError: error
  }
});
const setResponsesPageSize = dispatch => pageSize => dispatch({
  type: ACTION_TYPE.SET_RESPONSES_PAGE_SIZE,
  payload: {
    responsesPageSize: pageSize
  }
});
const setResponsesPage = dispatch => page => dispatch({
  type: ACTION_TYPE.SET_RESPONSES_PAGE,
  payload: {
    responsesPage: page
  }
});
const setResponsesCount = dispatch => count => dispatch({
  type: ACTION_TYPE.SET_RESPONSES_COUNT,
  payload: {
    responsesCount: count
  }
});
const setResponsesTotal = dispatch => total => dispatch({
  type: ACTION_TYPE.SET_RESPONSES_TOTAL,
  payload: {
    responsesTotal: total
  }
});
const setResponsesChanged = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_RESPONSES_CHANGED,
  payload: {
    responsesChanged: val
  }
});
const setShowSA = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_SHOW_SA,
  payload: {
    showSA: val
  }
});
const setSaStats = dispatch => saStats => dispatch({
  type: ACTION_TYPE.SET_SA_STATS,
  payload: {
    saStats
  }
});
const setSignificantChangesToResponses = dispatch => val => dispatch({
  type: ACTION_TYPE.SET_SIGNIFICANT_CHANGES_TO_RESPONSES,
  payload: {
    significantChangesResponses: val
  }
});
// sometimes we need to update multiple state values at once
const setMultiple = dispatch => payload => dispatch({
  type: ACTION_TYPE.SET_MULTIPLE,
  payload
});
export default {
  setResponses,
  setResponsesLoading,
  setResponsesError,
  setResponsesPageSize,
  setResponsesPage,
  setResponsesCount,
  setResponsesTotal,
  setResponsesChanged,
  setShowSA,
  setSaStats,
  setSignificantChangesToResponses,
  setMultiple
};